import PropTypes from 'prop-types';

const TickCircleSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 24}`}
      height={`${height || 24}`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill={color}
      />
      <path
        d="M10.5804 15.5796C10.3804 15.5796 10.1904 15.4996 10.0504 15.3596L7.22043 12.5296C6.93043 12.2396 6.93043 11.7596 7.22043 11.4696C7.51043 11.1796 7.99043 11.1796 8.28043 11.4696L10.5804 13.7696L15.7204 8.62961C16.0104 8.33961 16.4904 8.33961 16.7804 8.62961C17.0704 8.91961 17.0704 9.39961 16.7804 9.68961L11.1104 15.3596C10.9704 15.4996 10.7804 15.5796 10.5804 15.5796Z"
        fill={color}
      />
    </svg>
  );
};

TickCircleSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default TickCircleSvg;
